import '@/App.css';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider, useLanguage } from '@/lib/i18n';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import CookieConsent from '@/components/CookieConsent';
import HomePage from '@/pages/HomePage';
import ContactPage from '@/pages/ContactPage';
import PrivacyPage from '@/pages/PrivacyPage';
import TermsPage from '@/pages/TermsPage';

import CookiesPage from '@/pages/CookiesPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function LangRoute({ lang, children }) {
  const { setLang } = useLanguage();
  useEffect(() => { setLang(lang); }, [lang, setLang]);
  return children;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-background text-foreground">
          <Navbar />
          <Routes>
            <Route path="/" element={<LangRoute lang="es"><HomePage /></LangRoute>} />
            <Route path="/i" element={<LangRoute lang="en"><HomePage /></LangRoute>} />
            <Route path="/deutsch" element={<LangRoute lang="de"><HomePage /></LangRoute>} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/cookies" element={<CookiesPage />} />
          </Routes>
          <Footer />
          <CookieConsent />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
